import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import logo from './imgs/docpanel-logo-white.png';
import { Login } from './login/login'; 
import { LogOutWarning } from './login/logOutWarning'; 
import { Toaster } from 'react-hot-toast';
import {useRoutes, navigate, usePath} from 'hookrouter';

import { Orders } from './orders/orders'; 
import { LoadingMonitors } from './loadingMonitor/loadingMonitor'; 
import { Sweeps } from './sweeps/sweeps'; 
import { AccChecker } from './accChecker/accChecker'; 
import jwtDecode from 'jwt-decode';
import {
  logOutAsyncDocPanel
 } from './login/loginSlice';

import './App.css';
import { useSelector } from 'react-redux';
import {
 selectLoginData, setShowTimeOutWarning
} from './login/loginSlice'


const routes = {
  '/': () => <Login />,
  '/orders': () => <Orders />,
  '/sweeps': () => <Sweeps />,
  '/accChecker': () => <AccChecker />,
  '/LoadingMonitor': () => <LoadingMonitors />,
};

export const App = () => {

  const routeResult = useRoutes(routes);
    
  const dispatch = useDispatch();

  let { showTimeOutWarning, LoggedinDocPanel, jwt } = useSelector(selectLoginData);

  const currentPath = usePath();

  //let [showTimeOutWarning,setShowTimeOutWarning] = useState(false);

  //used to clear showTimeOut Modal
  useEffect(() => {
    let exp=0;
    const timeLeft = Math.abs((Date.now()/1000)-exp)/60;
 
      if ((parseInt(timeLeft,10) >= 3) && (showTimeOutWarning === true)) {
        setShowTimeOutWarning(false);
      }  
    },[jwt,showTimeOutWarning])

  useEffect(() => {
      let exp = 0;
      console.log('typeof jwt is ' + typeof jwt);
      if ((typeof jwt !== 'undefined') && (jwt !== null) && (jwt.length > 0)){
        const decoded = jwtDecode(jwt); 
        exp = decoded.exp
      }
      else {
        exp = 0;
      }
     

      if ((LoggedinDocPanel) && (showTimeOutWarning === false)) {
        console.log(showTimeOutWarning + ' is showtimeoutwarning')
        if (currentPath === "/") { 
          console.log('navigating to orders')
          navigate('/orders');
        }
      } 
      

        const interval = setInterval(() => {
        const timeLeft = Math.abs((Date.now()/1000)-exp)/60;
        console.log('exp calc next');
        console.log(Date.now() >= exp * 1000);
        if ((parseInt(timeLeft,10) >= 3) && ((parseInt(timeLeft,10) > 2))) {
          setShowTimeOutWarning(false);
          console.log('jwt must have refreshed')
        }
        
   
        console.log('in interval timeleft is ' + timeLeft);
        //in case someone was offline and wasn't logged out, this will log them out
        if (Date.now() >= exp * 1000) {
          dispatch(logOutAsyncDocPanel());
          dispatch(setShowTimeOutWarning(false));
          clearInterval(interval);
          navigate("/");
        };
        if ((parseInt(timeLeft,10) > 0) && (parseInt(timeLeft,10) <=2) && (showTimeOutWarning === false)) {
          console.log('settings showtimeoutwarning to true');
          dispatch(setShowTimeOutWarning(true));
        }

        if ((parseInt(timeLeft,10) <=0) && (LoggedinDocPanel === true)) {
          console.log("You are being logged out");
          dispatch(logOutAsyncDocPanel());
          console.log('exp is ' + exp);
          clearInterval(interval);
          dispatch(setShowTimeOutWarning(false));
          navigate("/");
        }
      },30000);
      return () => clearInterval(interval);

      
  },[jwt,dispatch,showTimeOutWarning,LoggedinDocPanel,currentPath])


  
  let headerClassName = (LoggedinDocPanel) ?  "App-header-loggedIn" : "App-header-loginPage" ;

  if ((LoggedinDocPanel === false) && (showTimeOutWarning === false)) {
      if (currentPath !== "/")  {
      navigate("/");
    }
  }


  return (
    <div className="App">
      <header className={headerClassName}>
        <img src={logo} className="App-logo" alt="logo" />
        {showTimeOutWarning && <LogOutWarning></LogOutWarning>}
        {routeResult};
        {/*(LoggedinDocPanel) ?   routeResult : <Login />*/}
      </header>
      <Toaster
      position="top-center"
      reverseOrder={false}
      />
    </div>
  );
}

export default App;
